import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Loader from '@/components/ui/Loader';
import useInfiniteScroll from '@/hooks/useInfiniteScroll';
import { useSidebarNewsStore } from '@/stores/local/sidebar/SidebarNewsStore';

import NewsItem from '../NewsItem';

import s from './NewsList.module.scss';

const NewsList: React.FC = () => {
  const store = useSidebarNewsStore();

  const ref = useInfiniteScroll(store.fetchMoreNews, store.hasMore);

  if (store.meta.isLoading || store.searchMeta.isLoading) {
    return <Loader gap={0} fullHeight type="dots" size="xl" text="Ищу новости..." />;
  }

  return (
    <Flex className={s.root} direction="column" gap="sm">
      {store.collection.items.map((news) => {
        return <NewsItem key={news.id} model={news} />;
      })}
      {store.nextPageMeta.isLoading && <Loader className={s.root__loader} gap={0} type="dots" size="sm" />}
      <div ref={ref} />
    </Flex>
  );
};

export default observer(NewsList);
